<!-- PaymentIcon.vue -->
<template>
  <svg :class="iconClass" width="24" height="24" viewBox="0 0 24 24" fill="none">                
    <path d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92484 18.0751 0.999977 12 0.999977C5.92487 0.999977 1 5.92484 1 12C1 18.0751 5.92487 23 12 23Z" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10"/>
    <path d="M12 23C14.7283 23 16.9401 18.0751 16.9401 12C16.9401 5.92484 14.7283 0.999977 12 0.999977C9.27168 0.999977 7.05994 5.92484 7.05994 12C7.05994 18.0751 9.27168 23 12 23Z" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10"/>
    <path d="M1.6489 8.26899H22.3511" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10"/>
    <path d="M1.6489 15.731H22.3511" stroke="#333333" stroke-width="1.5" stroke-miterlimit="10"/>
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>
